import styled from 'styled-components'

export const AsideStyle = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  width: 165px;
  height: 140px;

  flex-direction: column;

  @media(max-width: 800px) {
    position: fixed;
    width: 100%;
    height: auto;
    top: auto;
  }
`;

export const AsideStyleItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  color: #fff;
  right: -98px;
  padding: 8px;
  transition: all .8s ease;

  a {
    display: flex;
    width: 54px;

    img {
      width: 58px;
    }
  }

  .AsideStyleItem--text {
    width: 90px;
    margin-left: 11px;
    align-self: center;
    line-height: 10px;

    a {
      color: #f2fff7;
      font-size: 9px;
      line-height: 1.33;
      font-weight: bold;
    }
  }

  &.AsideStyleItem--one {
    background-color: #93da49;
  }
  &.AsideStyleItem--two {
    background-color: #1aaf97;
  }

  &:hover {
    right: 0 !important;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 20px;
    transition: all .8s ease;
  }

  @media(max-width: 800px) {
    right: auto;
    justify-content: center;
  }
`;

export const Toggle = styled.span`
  display: none;
  position: absolute;
  top: -10px;
  right: 9px;
  width: 25px;
  height: 25px;
  color: #fff;
  font-size: 25px;
  background: #007e78;
  border-radius: 50%;
  justify-content: center;
  cursor: pointer;
  z-index: 1;

  @media(max-width: 800px) {
    display: flex;
  }
`;